import { styled } from '@mui/material/styles';
import Tabs, { TabsProps } from '@mui/material/Tabs';

interface IProps extends TabsProps {
    size?: "large" | "medium" | "small";
    upperCase?: boolean;
}

export const MprcChipTabs = styled
    (({ centered, ...props }: TabsProps) =>
        (<Tabs {...props} centered={centered ?? (props.variant == "scrollable" ? false : true)} textColor="inherit" />),
        { shouldForwardProp: (propName: string) => propName != "upperCase" && propName != "size" })
    <IProps>(
        ({ theme, size = "small", upperCase = true }) => ({
            '&.MuiTabs-root': theme.extended.chipTab.tabs,
            '& .MuiTabs-indicator': theme.extended.chipTab.indicator,
            '& .MuiTabs-flexContainer': theme.extended.chipTab.container,
            '& .MuiTab-root': {
                ...theme.extended.chipTab.tab,
                fontSize: size == "large"
                    ? theme.extended.chipTab.large
                    : size == "medium"
                        ? theme.extended.chipTab.large
                        : theme.extended.chipTab.small,
                textTransform: upperCase ? "uppercase" : "unset",
                fontWeight: size == "large" ? "bold" : "unset"
            },
            '& .Mui-selected': theme.extended.chipTab.selected,
        })
    );
